/**
 * borrowed from NU ultipro-web
 */
import { APP_INITIALIZER, Provider } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FeatureToggleService, FeatureToggles } from './feature-toggle.service';
import { Util } from '../../../../util';
import { MockConfigService } from '../config/mock.config.service';
import { MockFeatureToggleService } from './mock.feature-toggle.service';
import { firstValueFrom } from 'rxjs';

const FeatureTogglesEndpoint = Util.prependHost('feature-toggles.json');

export async function fetchToggles(http: HttpClient, featureToggleService: FeatureToggleService) {
  if (featureToggleService instanceof MockFeatureToggleService) {
    return;
  }

  try {
    const toggles = await firstValueFrom(http.get<FeatureToggles>(FeatureTogglesEndpoint));

    featureToggleService.init(toggles);
  } catch (err) {
    console.error(
      `App could not start! Could not fetch feature toggles from endpoint '${FeatureTogglesEndpoint}'`,
      err
    );
    throw err;
  }
}

export function fetchTogglesFactory(
  http: HttpClient,
  featureToggleService: FeatureToggleService
): () => Promise<void> {
  return () => fetchToggles(http, featureToggleService);
}

export const FeatureToggleInitializer: Provider = {
  provide: APP_INITIALIZER,
  useFactory: fetchTogglesFactory,
  deps: [HttpClient, FeatureToggleService],
  multi: true,
};
